import { render } from "./CustomerOpenManifest.vue?vue&type=template&id=7ba16bde&scoped=true"
import script from "./CustomerOpenManifest.vue?vue&type=script&lang=js"
export * from "./CustomerOpenManifest.vue?vue&type=script&lang=js"

import "./CustomerOpenManifest.vue?vue&type=style&index=0&id=7ba16bde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba16bde"]])

export default __exports__